export const Label = ({ children }: { children: React.ReactNode }) => (
  <label className="block text-sm text-defaultSecondary">{children}</label>
)
